import AboutUs from "../components/aboutus/AboutUs";
import Layout from "../layout/Layout";

const AboutUsPage = () => {
  return (
    <Layout>
      <AboutUs />
    </Layout>
  );
};

export default AboutUsPage;
